import { T }    from 'defa-object';
/**
 * defa.views.ControlModuleErrorView
 * A generic ErrorView, displaying messages.
 * @version 1.0.0
 */
import View     from 'scripts/poppet/view';
import template from 'templates/controlModuleErrorView.jst.html';



const ControlModuleErrorView = View.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template : template,
	className: 'control-module card',
	
	templateContext: function () {
		return {
			title  : this.getTitle(),
			message: this.getMessage(),
		};
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	

	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	

	
	
	getMessage: function () {
		return !!this.model && this.model.get( 'message' )
			   || this.options.message
			   || '';
	},
	
	getTitle: function () {
		return !!this.model && this.model.get( 'title' )
			   || this.options.title
			   || T.tc( 'ErrorView', 'Error' );
	}
	
} );

export default ControlModuleErrorView;